import React from 'react';
import { Bell } from 'lucide-react';
import { motion } from 'framer-motion';

export const TopBar = () => {
  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className="sticky top-0 z-40 backdrop-blur-md bg-black/50 border-b border-white/5"
      data-testid="topbar"
    >
      {/* <div className="flex items-center justify-between h-16 px-6">
        <div className="flex-1"></div>
        
        <div className="flex items-center gap-4">
          <button
            data-testid="notifications-button"
            className="relative p-2 rounded-lg text-muted-foreground hover:text-white hover:bg-white/5 transition-colors"
          >
            <Bell className="w-5 h-5" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-accent rounded-full"></span>
          </button>
          
          <div className="flex items-center gap-3 pl-4 border-l border-white/10" data-testid="topbar-user">
            <img
              src="https://images.unsplash.com/photo-1615843423179-bea071facf96?auto=format&fit=crop&w=100&q=80"
              alt="User"
              className="w-8 h-8 rounded-full object-cover"
            />
          </div>
        </div>
      </div> */}
    </motion.header>
  );
};
